import { AppApiInstance } from "api/app-api";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PRODUCT_TYPE } from "utils/const";

const ContractOwnerInfo = (props) => {
  const {
    typeContract,
    fullName,
    phone,
    email,
    address,
    district,
    city,
    productType,
    contractDetail
  } = props;

  const { cities } = useSelector((state) => state.address);
  const [nameDistrict, setNameDistrict] = useState("");

  useEffect(() => {
    let isMounted = true;

    const region_code = contractDetail?.holderDetail?.person?.address?.region_code;
    const district_code = contractDetail?.holderDetail?.person?.address?.district_code;

    if (region_code && district_code) {
      AppApiInstance.getDistricts({ city: region_code })
        .then((res) => {
          if (!isMounted) return;
          const districtItem = res?.data?.getDistricts?.find(
            (f) => f.code === district_code
          );
          setNameDistrict(district || districtItem?.nameWithType || "");
        })
        .catch((err) => {
          console.error("Failed to fetch districts:", err);
        });
    }

    return () => {
      isMounted = false;
    };
  }, [contractDetail, district]);

  const renderAddress = () => {
    const region_code = contractDetail?.holderDetail?.person?.address?.region_code;
    const nameCity =
      city ||
      cities?.find((f) => f.code === region_code)?.nameWithType ||
      "";

    if ([PRODUCT_TYPE.motorbike_liability, PRODUCT_TYPE.car].includes(productType)) {
      return (
        <div className="row">
          <div className="row-left">Địa chỉ</div>
          <div className="row-right">
            {address === "..." ? "" : `${address}, `}{nameCity}
          </div>
        </div>
      );
    } else {
      return (
        <div className="row">
          <div className="row-left">Địa chỉ thường trú</div>
          {nameDistrict ? (
            <div className="row-right">
              {address}, {nameDistrict}, {nameCity}
            </div>
          ) : (
            <div className="row-right text-gray-400 italic">Đang tải địa chỉ...</div>
          )}
        </div>
      );
    }
  };

  return (
    <div className="bg-white padding-top-16 margin-bottom-16">
      <div className="margin-h-16 font-size-16 font-weight-bold margin-bottom-8 color-black">
        Thông tin chủ hợp đồng
      </div>
      <div className="row">
        <div className="row-left">Họ và tên</div>
        <div className="row-right">{fullName}</div>
      </div>
      <div className="row">
        <div className="row-left">Số điện thoại</div>
        <div className="row-right">{phone}</div>
      </div>
      {(!typeContract || typeContract !== "external-contract-detail") && (
        <>
          <div className="row">
            <div className="row-left">Email</div>
            <div className="row-right">{email}</div>
          </div>
          {renderAddress()}
        </>
      )}
    </div>
  );
};

export default React.memo(ContractOwnerInfo);
